(function () {
  function showToast(productName, productImage) {
    var toast = document.querySelector('.toast-notification');
    if (!toast) return;
    var toastProductName = toast.querySelector('.toast-notification__product-title');
    if (toastProductName) toastProductName.textContent = productName;
    var toastProductImage = toast.querySelector('.toast-notification__product-image');
    if (toastProductImage && productImage) toastProductImage.src = productImage;
    setTimeout(function () {
      toast.classList.add('active');
    }, 100);
    setTimeout(function () {
      toast.classList.remove('active');
    }, 3000);
  }

  function initCarousel(section) {
    var track = section.querySelector('[data-carousel-track]');
    var prevBtn = section.querySelector('[data-carousel-prev]');
    var nextBtn = section.querySelector('[data-carousel-next]');

    if (!track || !prevBtn || !nextBtn) return;

    function updateButtonStates() {
      var scrollLeft = track.scrollLeft;
      var scrollWidth = track.scrollWidth;
      var clientWidth = track.clientWidth;

      prevBtn.disabled = scrollLeft === 0;
      nextBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 10;
    }

    function scrollCarousel(direction) {
      var card = track.querySelector('[data-product-card]');
      var cardWidth = (card && card.offsetWidth) || 250;
      var gap = parseInt(getComputedStyle(track).gap) || 16;
      var pageDistance = cardWidth + gap;

      track.scrollBy({
        left: direction === 'next' ? pageDistance * 3 : -pageDistance * 3,
        behavior: 'smooth',
      });

      setTimeout(updateButtonStates, 300);
    }

    prevBtn.addEventListener('click', function () {
      scrollCarousel('prev');
    });
    nextBtn.addEventListener('click', function () {
      scrollCarousel('next');
    });
    track.addEventListener('scroll', updateButtonStates);
    updateButtonStates();

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollCarousel('prev');
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollCarousel('next');
      }
    });

    // Arrastar com o mouse (drag to scroll)
    var startX = 0;
    var scrollLeft = 0;
    var isDown = false;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
    });
    track.addEventListener('mouseleave', function () {
      isDown = false;
      track.style.cursor = 'grab';
    });
    track.addEventListener('mouseup', function () {
      isDown = false;
      track.style.cursor = 'grab';
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = x - startX;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  function initForms(section) {
    var forms = section.querySelectorAll('.product-card__form');
    forms.forEach(function (form) {
      form.addEventListener('submit', async function (e) {
        var button = form.querySelector('.product-card__button');
        var originalText = button ? button.textContent : '';
        if (!window.fetch) return;

        e.preventDefault();
        if (button) {
          button.disabled = true;
          button.textContent = 'Adicionando...';
        }

        try {
          var formData = new FormData(form);
          var variantId = formData.get('id');
          var quantity = formData.get('quantity') || 1;

          var cartDrawer = document.querySelector('cart-drawer');
          var sectionsToRender =
            cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
              ? cartDrawer.getSectionsToRender().map(function (s) {
                  return s.id;
                })
              : [];

          var response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
              sections: sectionsToRender,
              sections_url: window.location.pathname,
            }),
          });

          if (!response.ok) throw new Error('Failed to add product');

          var result = await response.json();
          showToast(result.title, result.featured_image && result.featured_image.url);

          if (typeof updateCartDrawer === 'function') {
            updateCartDrawer(Object.assign({}, result, { id: variantId }));
          }

          if (button) {
            button.textContent = originalText;
            button.disabled = false;
          }
        } catch (error) {
          console.error('Cart error:', error);
          if (button) {
            button.textContent = 'Erro - Tentar novamente';
            button.disabled = false;
            setTimeout(function () {
              button.textContent = originalText;
            }, 3000);
          }
        }
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll('.main-product-upsell-carousel');
    sections.forEach(function (section) {
      initCarousel(section);
      initForms(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
